import { add, addDays } from 'date-fns';
import { CartItem } from 'models/CartItem';
import { isRangeWithinInterval } from 'utils';
import { RelationSubItem } from './CheckoutProduct';
import { RelationshipType } from 'models/RelationshipType';
import { getPriceWithRent } from 'components/Shared/Price/selector';

interface IsValidProps {
  compareDate: Date;
  selectedDate: Date;
  returnRangeStartDate: Date;
  returnRangeEndDate: Date;
}

export const isValidPickupDate = ({
  compareDate,
  selectedDate,
  returnRangeStartDate,
  returnRangeEndDate
}: IsValidProps): boolean => {
  if (!selectedDate || !compareDate) return false;

  return (
    selectedDate < compareDate &&
    isRangeWithinInterval(compareDate, returnRangeStartDate, returnRangeEndDate)
  );
};

export const isValidReturnDate = ({
  compareDate,
  selectedDate,
  returnRangeStartDate,
  returnRangeEndDate
}: IsValidProps): boolean => {
  if (!selectedDate || !compareDate) return false;

  return (
    selectedDate > compareDate &&
    isRangeWithinInterval(selectedDate, returnRangeStartDate, returnRangeEndDate)
  );
};

export const calculateReturnRangeStartDate = (
  selectedPickupDate: Date | undefined,
  defaultReturnStartDate: Date
): Date => {
  return selectedPickupDate ? addDays(selectedPickupDate, 1) : defaultReturnStartDate;
};

export const calculateReturnRangeEndDate = (
  selectedPickupDate: Date | undefined,
  defaultReturnStartDate: Date
): Date => {
  return selectedPickupDate
    ? add(selectedPickupDate, { months: 3 })
    : add(defaultReturnStartDate, { months: 3, days: -1 });
};

export const getOriginalPrice = (item: CartItem, relations: CartItem[]) => {
  const subItemTotal = relations.reduce((subItemTotal, subItem: RelationSubItem) => {
    if (subItem.itemType === RelationshipType.Subitem) {
      return subItemTotal;
    }

    return subItemTotal + subItem.originalPrice.amount * subItem.quantity.amount;
  }, 0);

  const itemPrice = item.originalPrice.amount * item.quantity.salesQuantity;

  return itemPrice + subItemTotal;
};

export const getPrice = (item: CartItem, relations: CartItem[]) => {
  const subItemTotal = relations.reduce((subItemTotal, subItem: RelationSubItem) => {
    if (subItem.itemType === RelationshipType.Package) {
      return subItemTotal;
    }

    const price = getPriceWithRent(subItem);
    return subItemTotal + price;
  }, 0);

  const price = getPriceWithRent(item);
  return subItemTotal + price;
};
